import { render, staticRenderFns } from "./contact-list-page.vue?vue&type=template&id=b87b96ce&scoped=true&"
import script from "./contact-list-page.vue?vue&type=script&lang=js&"
export * from "./contact-list-page.vue?vue&type=script&lang=js&"
import style0 from "./contact-list-page.vue?vue&type=style&index=0&id=b87b96ce&lang=scss&scoped=true&"
import style1 from "./contact-list-page.vue?vue&type=style&index=1&id=b87b96ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87b96ce",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QCard})
